module.exports = __webpack_public_path__ + "ICONLocation.svg?694858f6d01bd04b09e3be07167c9c96";


//////////////////
// WEBPACK FOOTER
// ./static/ICONLocation.svg
// module id = 311
// module chunks = 0